import Vue from 'vue'
import VueRouter from 'vue-router'

//custom components
import VehiclesListsPage from "@/pages/VehiclesListsPage";
import DevicesPage from "@/pages/DevicesPage";
import NetworkPage from "@/pages/NetworkPage";
import SecurityPage from "@/pages/SecurityPage";
import SystemPage from "@/pages/SystemPage";
import RecognitionJournal from "@/pages/RecognitionJournal";
import SideMenu from "@/pages/SideMenu";
import LoginPage from "@/pages/LoginPage";
import CheckpointsAndGatesPage from "@/pages/CheckpointsAndGatesPage";


// eslint-disable-next-line no-unused-vars
function load(component) {
  return () => import(`@/pages/${component}.vue`)
}

import store from "@/store";
// eslint-disable-next-line no-unused-vars
import {i18n} from "@/i18n";
// eslint-disable-next-line no-unused-vars
import {Trans} from "@/plugins/transition";
import DebugTool from "../pages/DebugTool";
Vue.use(VueRouter)

const routes = [
    {
        path: '/:locale',
        component: {
          template: "<router-view></router-view>"
        },
        beforeEnter: Trans.routeMiddleware,
        children: [
            {
                path: 'side_menu',
                name: 'SideMenu',
                component: SideMenu,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'recognition_journal',
                name: 'RecognitionJournal',
                component: RecognitionJournal,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'vehicles_lists',
                name: 'VehiclesLists',
                component: VehiclesListsPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'checkpoints_and_gates',
                name: 'Checkpoints',
                component: CheckpointsAndGatesPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'cameras_and_relays',
                name: 'Devices',
                component: DevicesPage,
                meta: {
                    requiresAuth: true
                }
            },
             {
                path: 'network_settings',
                name: 'Network',
                component: NetworkPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'users',
                name: 'Security',
                component: SecurityPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'system_settings',
                name: 'System',
                component: SystemPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'debug_tool',
                name: 'DebugTool',
                component: DebugTool,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'login',
                name: 'Login',
                component: LoginPage
            }
        ]
    },
    {
        path: '*',
        redirect() {
          return Trans.defaultLocale
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach(async(to, from, next) => {
    await Vue.nextTick()
    let link_parts = to.fullPath.split('/')
    if (store.getters.isLoggedIn === null) await store.dispatch('isUserLoggedIn')
    if (store.getters.loadingOverlay.reload_required) {
        store.dispatch('setSnackbar', {text: i18n.t('notifications.common.saving_changes')})
        store.dispatch('updateLoadingOverlay', {is_loading: true, reload_required: false})
        store.dispatch('sendSocketMessage', {method: 'system_reload', params: ''})
        // await new Promise(r => setTimeout(r, 1000)); // Костыль, 1 секунду ждём от сервера событие отображения загрузки
        // if (store.getters.loadingOverlay.is_loading) {
        //     store.dispatch('setSnackbar', {text: i18n.t('notifications.common.saving_changes')})
        // }
        while (store.getters.loadingOverlay.is_loading) {
            await new Promise(r => setTimeout(r, 1000));
        }
    }
    if (store.getters.isLoggedIn === false) {
        if (link_parts[link_parts.length - 1] !== 'login') {
         next(Trans.i18nRoute({name: 'Login'}))
        } else {
            next()
        }
     return
    }
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            if (
                store.state.user.access_to_tabs.includes(link_parts[link_parts.length - 1]) || (to.name === 'DebugTool')
            ) {
                next()
            }
        }
      } else {
        next()
      }
})
export default router